import { useEffect } from "react";
import { useDispatch } from "react-redux";

import PrivateLayoutFrame from "../../helpers/PrivateLayoutFrame/PrivateLayoutFrame";
import { setThemeAction } from "../../redux/actions/themeActions/themeActions";

const CustomerLayout = ({ children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setThemeAction({ apps: "theme" }));
  }, []);

  return <PrivateLayoutFrame>{children}</PrivateLayoutFrame>;
};

export default CustomerLayout;
